<template>
  <div class="warp warp_enterprise warp_zhapin" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat;'">
      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>


    <div class="modle_16" v-if="data_list">

      <div class="group cle">
        <div class="item cle" v-scroll-reveal v-for="(item,index) in data_list" :key="index">
          <div class="let fl">
            <div class="t1">
              {{item.title}}
            </div>
            <div class="t2">
              {{item.introduce}}
            </div>
          </div>

          <div class="rit fr" v-scroll-reveal>

            <div class="t">
              <img :src="item.img1" style="width: 100%;" />
            </div>
            <div class="cle imgs">

              <div class="it fl">
                <img :src="item.img2" />
              </div>
              <div class="it fr">
                <img :src="item.img3" />
              </div>

            </div>

          </div>


        </div>
      </div>

    </div>







  </div>
</template>

<script>
  import {
    postcultureAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //
        data_list: null


      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        postcultureAPI().then(function(res) {
          that.data = res.data.data;
          that.data_list = res.data.data.list[0].list;
          //  console.log(that.data_list[0].list);
        }).catch(function(err) {
          console.log(err);
        })
      },


    },
    mounted() {
      this.getList();

    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }


  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .warp_zhapin {
    font-family: 'OPPOSans-L';
    padding-bottom: 0px !important;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .modle_16 {
    width: 95%;
    max-width: 1200px;
    margin: 0px auto;
    margin-top: 160px;

    .item {
      margin-bottom: 150px;

      .let {
        width: 45%;
        text-align: left;
        padding-top: 90px;

        .t1 {
          font-size: 35px;
          color: #000000;
          font-weight: bold;
          margin-bottom: 40px;
          background: url(/static/img/p16.png) left center no-repeat;
          padding-left: 50px;

        }

        .t2 {
          font-size: 20px;
          color: #323232;
          padding-left: 50px;
        }
      }

      .rit {
        width: 48%;

        .imgs {
          margin-top: 10px;

          .it {
            width: 49%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/culture/culture.vue